import {Component, Input, OnInit} from '@angular/core'
import {Vendors} from '../../vendor.items/list/list.service'


// USING FOR ADMIN MODE
@Component({
    selector: 'app-company-vendor-items',
    templateUrl: 'cmp.details.component.html',
    styleUrls: ['cmp.details.component.css'],
    standalone: false
})
export class CompanyVendorItemsComponent implements OnInit {
  @Input() vis: Vendors[]
  @Input() category: string
  @Input() addCounter?: boolean
  @Input() sorted?: boolean

  constructor() {
  }

  ngOnInit() {
    console.log('CPM-Details: ', this)
  }
}
